module.exports = __webpack_public_path__ + "static/img/filters.b45f53fb.svg";